import React from 'react';
import Meld from './Meld';
import InstructorSidebar from './InstructorSidebar';
import { useAuth } from '../auth/AuthContext';
import { Box } from '@mui/material';
import TutorialManager from "./TutorialManager";
import './App.css';


const Home = ({ currentModel, modelData, updateModelData, isInfoPanelOpen, toggleInfoPanel, handleModelSelect, activeStudentModel }) => {
    const { currentUser } = useAuth();
    const isInstructor = currentUser?.role === 'instructor';

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {isInstructor && (
                <InstructorSidebar
                    currentModel={currentModel}
                    onModelSelect={handleModelSelect}
                />
            )}
            <Box sx={{ flex: 1, position: 'relative' }}>
                {modelData && (
                    <Meld
                        currentMEL={currentModel}
                        melData={modelData}
                        updateMELData={(mel, data) => updateModelData(mel, data)}
                        isInfoPanelOpen={isInfoPanelOpen}
                        toggleInfoPanel={toggleInfoPanel}
                        activeStudentModel={activeStudentModel}
                    />
                )}
                <button
                    className={`info-panel-toggle ${isInfoPanelOpen ? 'open' : ''}`}
                    onClick={toggleInfoPanel}
                >
                    <span className="icon">+</span>
                </button>
            </Box>
             <TutorialManager />
        </Box>
    );
};

export default Home;